module.exports = __webpack_public_path__ + "1569b22d0f5ec171d7edb296a1c36439.png";